module.exports = __webpack_public_path__ + "static/media/logo_pl_invert_nl.e31c5450.svg";